import React from 'react';
export function BonusSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="bonus" className="py-5 sm:py-14 bg-[#0f172a] relative" data-id="element-30">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-31">
        <div className="text-center mb-3 sm:mb-8" data-id="element-32">
          <h2 className="text-lg sm:text-3xl md:text-4xl font-bold text-white mb-1 sm:mb-4" data-id="element-33">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <p className="text-xs sm:text-base text-gray-300 max-w-2xl mx-auto mb-3 sm:mb-6" data-id="element-34">
            Para que puedas organizar mejor tu año, tener respaldo profesional y
            contar con más recursos prácticos, sumamos 3 bonus listos para usar:
          </p>

          <div className="inline-block bg-gradient-to-r from-red-600 to-red-500 text-white font-black text-[10px] sm:text-base md:text-lg px-3 sm:px-6 py-1 sm:py-2 rounded-lg shadow-lg border-2 border-white/20" data-id="element-35">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6" data-id="element-36">
          {/* Bonus 1 */}
          <div className="bg-[#1e293b] rounded-xl overflow-hidden border-2 border-[#fbbf24]/50 hover:border-[#fbbf24] transition-all shadow-xl flex flex-col" data-id="element-37">
            <div className="bg-[#fbbf24]/10 p-1.5 sm:p-3 text-center border-b border-[#fbbf24]/20" data-id="element-38">
              <h3 className="text-sm sm:text-lg font-bold text-[#fbbf24]" data-id="element-39">
                BONUS #1
              </h3>
            </div>
            <div className="p-2.5 sm:p-5 flex-1 flex flex-col items-center" data-id="element-40">
              <div className="w-full max-w-[160px] aspect-square mb-2 sm:mb-4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/ejjiUNdyCP5oxmX88RJLsg/bonus_planificacion_anual.png" alt="Bonus 1 Planificación" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-42" />
              </div>
              <h4 className="text-sm sm:text-lg font-bold text-white mb-0.5 sm:mb-2 text-center leading-tight" data-id="element-43">
                Guía Maestra de Planificación Anual
              </h4>
              <p className="text-gray-300 text-center text-[10px] sm:text-sm" data-id="element-44">
                Modelo estructurado para organizar todo el año lectivo de
                Geografía, con planificación editable y adaptable a tu
                institución y provincia.
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-[#1e293b] rounded-xl overflow-hidden border-2 border-[#fbbf24]/50 hover:border-[#fbbf24] transition-all shadow-xl flex flex-col" data-id="element-45">
            <div className="bg-[#fbbf24]/10 p-1.5 sm:p-3 text-center border-b border-[#fbbf24]/20" data-id="element-46">
              <h3 className="text-sm sm:text-lg font-bold text-[#fbbf24]" data-id="element-47">
                BONUS #2
              </h3>
            </div>
            <div className="p-2.5 sm:p-5 flex-1 flex flex-col items-center" data-id="element-48">
              <div className="w-full max-w-[160px] aspect-square mb-2 sm:mb-4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-49">
                <img src="https://cdn.magicpatterns.com/uploads/x7VdE4PoP1mXRXDXshnKQS/bonus_primeros_auxilios.png" alt="Bonus 2 Primeros Auxilios" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-50" />
              </div>
              <h4 className="text-sm sm:text-lg font-bold text-white mb-0.5 sm:mb-2 text-center leading-tight" data-id="element-51">
                Guía Docente de Primeros Auxilios
              </h4>
              <p className="text-gray-300 text-center text-[10px] sm:text-sm" data-id="element-52">
                Material práctico de apoyo para situaciones escolares
                frecuentes, pensado para acompañar al docente en contextos
                reales del aula.
              </p>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-[#1e293b] rounded-xl overflow-hidden border-2 border-[#fbbf24]/50 hover:border-[#fbbf24] transition-all shadow-xl flex flex-col" data-id="element-53">
            <div className="bg-[#fbbf24]/10 p-1.5 sm:p-3 text-center border-b border-[#fbbf24]/20" data-id="element-54">
              <h3 className="text-sm sm:text-lg font-bold text-[#fbbf24]" data-id="element-55">
                BONUS #3
              </h3>
            </div>
            <div className="p-2.5 sm:p-5 flex-1 flex flex-col items-center" data-id="element-56">
              <div className="w-full max-w-[160px] aspect-square mb-2 sm:mb-4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-57">
                <img src="https://cdn.magicpatterns.com/uploads/3vCB3AVEMLgVrhkPLnWx9e/bonus_maletin_de_act.png" alt="Bonus 3 Maletín" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-58" />
              </div>
              <h4 className="text-sm sm:text-lg font-bold text-white mb-0.5 sm:mb-2 text-center leading-tight" data-id="element-59">
                Maletín de Actividades
              </h4>
              <p className="text-gray-300 text-center text-[10px] sm:text-sm" data-id="element-60">
                Banco ampliado de actividades listas para usar, dinámicas,
                consignas y propuestas aplicables en distintas unidades y
                cursos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}